import React, { useState, useEffect } from 'react';
import { getLastResults, getDetailResults } from '@/services/casinoApi';
import "./Result.css";
import ResultModalLayout from '@/components/ResultModalLayout';

// Map win value to winner name
const mapWinToWinner = (winValue) => {
  const win = winValue?.toString() || "0";
  switch (win) {
    case "1":
      return "Don";
    case "2":
      return "Amar Akbar Anthony";
    case "3":
      return "Sahib Bibi Aur Ghulam";
    case "4":
      return "Dharam Veer";
    case "5":
      return "Kis Kis Ko Pyaar Karoon";
    case "6":
      return "Ghulam";
    default:
      return "";
  }
};

// Helper function to get card image from card code
const getCardImage = (cardCode) => {
  if (!cardCode) return null;
  return `/assets/img/cards/${cardCode}.png`;
};

// Parse rdesc to extract result details
const parseRdesc = (rdesc) => {
  if (!rdesc) return { winner: "", odd: "", dulhaBarati: "", color: "", card: "" };
  
  const parts = rdesc.split('#');
  return {
    winner: parts[0] || "",
    odd: parts[1] || "",
    dulhaBarati: parts[2] || "",
    color: parts[3] || "",
    card: parts[4] || ""
  };
};

const ResultBtTable = ({
  data = [],
  gameData = {},
  gameType = 'btable',
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedResult, setSelectedResult] = useState(null);
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch last results on mount
  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(gameType);
        if (response?.success && response?.data?.data?.res) {
          setLastResults(response.data.data.res);
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };

    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [gameType]);

  const handleResultClick = async (resultItem, index) => {
    setSelectedResult(resultItem);
    setLoading(true);

    const mid = resultItem?.mid;

    if (mid) {
      try {
        const response = await getDetailResults(gameType, mid.toString());
        if (response?.success && response?.data?.data?.t1) {
          setDetailResult(response.data.data.t1);
        }
      } catch (error) {
        console.error('Error fetching detail results:', error);
      }
    }

    setLoading(false);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedResult(null);
    setDetailResult(null);
  };

  // Format modal data
  const getModalData = () => {
    if (!selectedResult || !detailResult) return null;

    const rdescData = parseRdesc(detailResult.rdesc);
    const cardCode = detailResult.card || "";
    const cardImage = getCardImage(cardCode);

    return {
      roundId: detailResult.rid || gameData?.data?.data?.mid || gameData?.mid || "N/A",
      matchTime: detailResult.mtime || gameData?.data?.data?.mt || new Date().toLocaleString(),
      cardImage: cardImage,
      cardCode: cardCode,
      resultDetails: {
        winner: rdescData.winner || detailResult.winnat || "",
        odd: rdescData.odd || "",
        dulhaBarati: rdescData.dulhaBarati || "",
        color: rdescData.color || "",
        card: rdescData.card || ""
      }
    };
  };

  const modalData = getModalData();

  // Combine API results with fallback data
  const allResults = lastResults.length > 0
    ? lastResults
    : data.map((res, idx) => ({ win: res, mid: null }));

  return (
    <>
      {/* Last Results Section */}
      <div className="casino-last-results">
        {allResults.map((resultItem, index) => {
          const winnerName = mapWinToWinner(resultItem.win);
          const firstLetter = winnerName ? winnerName.charAt(0) : "";

          return (
            <span
              key={index}
              className="result"
              onClick={() => resultItem.mid && handleResultClick(resultItem, index)}
              style={{ cursor: resultItem.mid ? 'pointer' : 'default' , color:'yellow'}}
            >
              {firstLetter}
            </span>
          );
        })}
      </div>

      {/* Modal */}
      {modalData && (
        <ResultModalLayout
          show={showModal}
          onHide={handleCloseModal}
          title="B Table Result"
          roundId={modalData.roundId}
          matchTime={modalData.matchTime}
          loading={loading}
        >
          <div className="modal-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <h6 className="text-right">
                    <b>Round Id :</b> {modalData.roundId}
                  </h6>
                </div>
              </div>
              <div className="row bottom-border-casino m-t-10">
                <div className="col-md-12">
                  <div className="player-image-container row">
                    <div className="text-center player-number col-12">
                      {modalData.cardImage && (
                        <img 
                          src={modalData.cardImage} 
                          alt={modalData.cardCode}
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      )}
                      <div className="col-md-12 text-left">
                        {modalData.resultDetails.winner && (
                          <p className="m-b-0 m-t-20">
                            <b>Winner:</b> {modalData.resultDetails.winner}
                          </p>
                        )}
                        {modalData.resultDetails.odd && (
                          <p className="m-b-0">
                            <b>Odd:</b> {modalData.resultDetails.odd}
                          </p>
                        )}
                        {modalData.resultDetails.dulhaBarati && (
                          <p className="m-b-0">
                            <b>Dulha Dulhan/Barati:</b> {modalData.resultDetails.dulhaBarati}
                          </p>
                        )}
                        {modalData.resultDetails.color && (
                          <p className="m-b-0">
                            <b>Color:</b> {modalData.resultDetails.color}
                          </p>
                        )}
                        {modalData.resultDetails.card && (
                          <p className="m-b-0">
                            <b>Card:</b> {modalData.resultDetails.card}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ResultModalLayout>
      )}
    </>
  );
};

export default ResultBtTable;

